var _linearGradient, _linearGradient2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3980.9268,
    height: 3121.1128,
    viewBox: "0 0 3980.9268 3121.1128",
    xmlSpace: "preserve",
    id: "svg1535",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs1421"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient7278"
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 0.64285713
    },
    offset: 0,
    id: "stop7274"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 0.64285713
    },
    offset: 0.39015019,
    id: "stop7282"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 0.32467532
    },
    offset: 0.68817204,
    id: "stop7284"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffffff",
      stopOpacity: 0
    },
    offset: 1,
    id: "stop7276"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_174_1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(3.1092377,-2.9944227,2.9944227,3.1092377,48.313156,3274.6812)",
    x1: 0,
    y1: 50,
    x2: 1042,
    y2: 50,
    spreadMethod: "pad"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#6C3BF4",
      stopOpacity: 1
    },
    id: "stop1457"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "#C53BF4",
      stopOpacity: 1
    },
    id: "stop1459"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#6C3BF4",
      stopOpacity: 1
    },
    id: "stop1461"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1280_0",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(3.7334825,0.02196153,-0.02196153,3.7334825,101.2572,2121.9057)",
    x1: 513.50171,
    y1: -7.4990935,
    x2: 521.1709,
    y2: 501.43939
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 1
    },
    id: "stop1429"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "38.23352592550473%",
    style: {
      stopColor: "#FFFCF7",
      stopOpacity: 1
    },
    id: "stop1431"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#DCD2C4",
      stopOpacity: 1
    },
    id: "stop1433"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#SVGID_174_1",
    id: "linearGradient1412",
    x1: 50.905506,
    y1: 1885.4478,
    x2: 3658.644,
    y2: 1885.4478,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0.61943586,0.60362525,-0.60362525,0.61943586,2050.8661,-313.27076)"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#linearGradient7278",
    id: "linearGradient7280",
    x1: 322.98303,
    y1: 2766.2522,
    x2: 290.97495,
    y2: 2366.0308,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0.86175681,0.07375247,-0.07375247,0.86175681,2064.2783,-295.21542)"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fontVariationSettings: "normal",
      display: "none",
      opacity: 1,
      vectorEffect: "none",
      fill: "none",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeWidth: 250,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.340476,
      InkscapeStroke: "none",
      stopColor: "#000000",
      stopOpacity: 1
    },
    d: "m 413.40881,1644.4052 c 0,0 -158.03672,-380.2804 74.78572,-822.64303 186.96436,-355.2322 -287.92504,-418.8 -224.35717,-774.032234 63.56786,-355.232196 48.61072,-284.185756 48.61072,-284.185756",
    id: "path8115-7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontVariationSettings: "normal",
      display: "none",
      fill: "none",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeWidth: 250,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.340476,
      stopColor: "#000000"
    },
    d: "m 1153.1577,1038.1852 c 0,0 -209.40002,-302.88223 14.9571,-538.45721 C 1392.472,264.1529 891.40766,264.1529 925.06123,-5.075714 958.71488,-274.30432 958.71488,-274.30432 958.71488,-274.30432",
    id: "path8117-5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontVariationSettings: "normal",
      display: "none",
      fill: "none",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeWidth: 250,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.340476,
      stopColor: "#000000"
    },
    d: "m 1758.9221,581.99217 c 0,0 -134.6143,-314.09998 14.9571,-534.717874 149.5714,-220.617886 33.6535,-332.796476 33.6535,-332.796476",
    id: "path8244-7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "none",
      fill: "none",
      stroke: "#ffffff",
      strokeWidth: 500,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "M 116.72003,2288.0338 C 1099.262,1422.8414 1927.9317,579.08817 2739.6653,-306.19936 c 370.6134,200.25105 923.5879,357.394616 1181.576,634.85052 L 3701.0152,2360.6021 c 0,0 -45.4205,907.9682 -927.3706,940.8034 C 1891.6947,3334.2409 708.76144,3484.6233 708.76144,3484.6233 379.57225,3219.7163 271.78557,2655.4482 116.72003,2288.0338 Z",
    id: "path991"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g1385",
    transform: "translate(-55.137157,-899.47356)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "url(#SVGID_1280_0)",
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 86.4907,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "m 101.2537,2121.913 -2.871205,488.1 744.824575,616.3576 685.82223,567.5322 v 0 c 292.7058,242.2201 715.5474,245.0054 1011.4191,6.6624 l 1449.4991,-1167.6608 2.8709,-488.0999 z",
    strokeLinecap: "round",
    id: "path1436"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 72.7315,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    d: "M 1484.4848,3748.412 118.52465,2620.1127 c 0,0 1027.76455,205.761 1410.92225,1158.5641",
    strokeLinecap: "round",
    id: "path1442-9-2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 72.7315,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 0.976562
    },
    d: "m 2582.6235,3756.7352 1381.314,-1109.4494 c 0,0 -1030.4913,191.6386 -1426.6872,1139.0943",
    strokeLinecap: "round",
    id: "path1442-9-2-8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cfc8e1",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "0.864907px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 279.89302,2702.2155 c 0,0 1136.56088,952.9979 1157.21178,958.3519 20.6508,5.3538 -329.6486,-692.1856 -1157.21178,-958.3519 z",
    id: "path4640"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "#cfc8e1",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: "0.864907px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeOpacity: 1
    },
    d: "m 3803.916,2727.96 c 0,0 -1157.4039,937.4266 -1167.4946,937.4266 -10.0907,0 292.6305,-655.8959 1167.4946,-937.4266 z",
    id: "path5263"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillOpacity: 0,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 86.4907,
      strokeLinecap: "round",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "m 1579.6405,3194.6383 77.0173,54.92 21.8525,15.5824 v 0 c 108.8818,77.642 247.3027,101.0244 375.6004,63.4477 157.3631,-46.0895 278.0626,-87.6251 444.6101,-222.031",
    strokeLinecap: "round",
    id: "path1445"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      fill: "url(#linearGradient1412)",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 72.7318,
      strokeLinecap: "butt",
      strokeLinejoin: "bevel",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "m 476.22766,1533.6591 c 1141.82424,125.365 1985.95084,119.7672 3189.28474,-0.9067 l 333.1445,609.2847 -3908.384225,-17.3269 z",
    id: "path1464"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g1124",
    transform: "matrix(0.67345286,0.6562635,-0.65125209,0.66831018,1895.7278,-650.27349)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000000",
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 0,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "m 1002.9101,3174.3896 2142.8724,-2063.7425 156.6451,162.8049 -82.3809,79.339 79.1674,82.4334 -82.3811,79.339 79.2825,82.3224 -82.4933,79.4471 79.2827,82.3225 -577.7052,556.3723 -79.0984,-82.5002 -88.0591,73.6732 -73.7194,-76.5458 -82.6675,79.6147 -158.3144,-164.8866 -164.9893,158.8968 158.5649,164.6452 -82.5624,79.5138 79.2826,82.3224 -82.573,79.5237 79.2825,82.3226 -579.3551,557.9611 -79.2825,-82.3225 -80.5523,77.5779 -81.0856,-80.5861 -80.5781,77.6027 -79.3975,-82.2117 -80.4631,77.4917 z",
    strokeLinecap: "round",
    id: "path1493"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 5.3202,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "m 2481.9439,2068.9033 82.8277,-79.085 79.3237,82.2828 -82.5269,79.4793 z",
    strokeLinecap: "round",
    id: "path1496"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 5.3202,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "m 2643.7575,2071.7767 82.8277,-79.0852 79.3236,82.2828 -82.5269,79.4795 z",
    strokeLinecap: "round",
    id: "path1499"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 5.3202,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "m 2485.35,1906.9114 82.8277,-79.0851 79.3238,82.2828 -82.5271,79.4795 z",
    strokeLinecap: "round",
    id: "path1502"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 5.3202,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "m 1405.2731,3102.053 82.8274,-79.0851 79.3238,82.2827 -82.5269,79.4796 z",
    strokeLinecap: "round",
    id: "path1505"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 5.3202,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "m 2320.2839,2065.8822 82.8276,-79.0853 79.3238,82.283 -82.5271,79.4796 z",
    strokeLinecap: "round",
    id: "path1508"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 5.3202,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "m 1567.0865,3104.9263 82.8276,-79.0853 79.3237,82.2829 -82.5269,79.4797 z",
    strokeLinecap: "round",
    id: "path1511"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 5.3202,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "m 2647.0102,1909.9325 82.8276,-79.0852 79.3239,82.2828 -82.5272,79.4797 z",
    strokeLinecap: "round",
    id: "path1514"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 5.3202,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "m 1408.6791,2940.061 82.8275,-79.0849 79.3239,82.2828 -82.5271,79.4794 z",
    strokeLinecap: "round",
    id: "path1517"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 5.3202,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "m 2808.7854,1912.8427 82.8276,-79.0852 79.3237,82.2828 -82.5269,79.4796 z",
    strokeLinecap: "round",
    id: "path1520"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 5.3202,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "m 1243.6129,3099.0319 82.8276,-79.0851 79.3237,82.2828 -82.5269,79.4795 z",
    strokeLinecap: "round",
    id: "path1523"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 5.3202,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "m 1570.3393,2943.0823 82.8274,-79.0853 79.3239,82.283 -82.527,79.4794 z",
    strokeLinecap: "round",
    id: "path1526"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      fillRule: "nonzero",
      stroke: "#000000",
      strokeWidth: 5.3202,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0
    },
    d: "m 1732.1143,2945.9925 82.8277,-79.0852 79.3236,82.2828 -82.5269,79.4795 z",
    strokeLinecap: "round",
    id: "path1529"
  })), /*#__PURE__*/React.createElement("path", {
    id: "rect1916",
    style: {
      display: "inline",
      fill: "url(#linearGradient7280)",
      fillOpacity: 1,
      strokeWidth: 103.789,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      paintOrder: "stroke markers fill",
      stopColor: "#000000"
    },
    d: "m 339.41512,1810.3083 c 1154.33698,7.9775 2302.36598,9.6468 3434.36378,-4.715 l 166.3073,300.4189 -3785.24747,-16.6305 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontVariationSettings: "normal",
      opacity: 1,
      vectorEffect: "none",
      fill: "none",
      fillOpacity: 1,
      stroke: "#927a65",
      strokeWidth: 86.4907,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      InkscapeStroke: "none",
      stopColor: "#000000",
      stopOpacity: 1
    },
    d: "m 2718.7437,1430.859 c 0,0 -33.8542,-184.404 113.5013,-225.4471 141.489,-39.409 165.8435,-265.25442 148.4904,-262.7754",
    id: "path8244"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontVariationSettings: "normal",
      vectorEffect: "none",
      fill: "none",
      fillOpacity: 1,
      stroke: "#927a65",
      strokeWidth: 86.4907,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      InkscapeStroke: "none",
      stopColor: "#000000"
    },
    d: "m 1929.984,1430.859 c 0,0 -33.8542,-184.404 113.5013,-225.4471 141.489,-39.409 165.8435,-265.25445 148.4904,-262.77543",
    id: "path8244-8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fontVariationSettings: "normal",
      vectorEffect: "none",
      fill: "none",
      fillOpacity: 1,
      stroke: "#927a65",
      strokeWidth: 86.4907,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1,
      InkscapeStroke: "none",
      stopColor: "#000000"
    },
    d: "m 1141.2243,1430.859 c 0,0 -33.8542,-184.404 113.5013,-225.4471 141.489,-39.409 165.8435,-265.25444 148.4904,-262.77544",
    id: "path8244-3"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.89b0b998e571b41516587fda1a855fd3.svg";
export { ForwardRef as ReactComponent };